import { useCallback } from 'react';

import { createZustandContextStore } from './utils/createZustandContextStore';

type HorizonFlashMessageStoreState = {
  flashMessage: FlashMessageType | null;
};

const {
  ZustandContextProvider,
  useZustandContextStore,
  useZustandContextSelector,
} = createZustandContextStore<HorizonFlashMessageStoreState>({
  fallbackState: {
    flashMessage: null,
  },
});

export const HorizonFlashMessageStoreProvider = ZustandContextProvider;

// Hookz

export function useHorizonFlashMessage(): {
  horizonFlashMessage: FlashMessageType | null;
} {
  const horizonFlashMessage = useZustandContextSelector(
    (state) => state.flashMessage,
  );

  return { horizonFlashMessage };
}

export function useHorizonFlashMessageActions() {
  const store = useZustandContextStore();

  const clearHorizonFlashMessage = useCallback(() => {
    store.setState({ flashMessage: null });
  }, [store]);

  return { clearHorizonFlashMessage };
}
